export default __webpack_public_path__ + "a0f5d7e05ff7a6a7491f5a02594a1177.png";